import SimpleLayout from "../../core/components/layout/SimpleLayout";
import {useEffect, useState} from "react";
import {t} from "i18next";
import AppConfig from "../../core/service/AppConfig";
import {Card, Select} from "antd";
import {useUser} from "../../core/context/UserContext";
import ApiService from "../../core/service/ApiService";

export default function DashboardApp() {
    const {user} = useUser()
    const [id, setId] = useState(null)
    const [link, setLink] = useState('')

    const createLink = async () => {
        const res = await ApiService.User.GetDashboardLink(id)
        if(res.success) {
            setLink(res.data)
        }
    }

    useEffect(() => {
        document.title = `${t('Dashboard')} - ${AppConfig.getHisTitle()}`;
    }, []);

    useEffect(() => {
        if(id) {
            createLink()
        }
    }, [id])

    useEffect(() => {
        if(user?.userDashboards?.length > 0 && !id) {
            setId(user.userDashboards[0].id)
        }
    }, [user]);

    return (
        <>
            <SimpleLayout fullWidth={true}>
                <Card>
                    <Select
                        size={'small'}
                        style={{width:400}}
                        placeholder={t('Dashboard')}
                        value={id}
                        onChange={(e) => setId(e)}
                    >
                        {
                            user?.userDashboards?.map(dashboard => (
                                <Select.Option key={dashboard.id} value={dashboard.id}>
                                    {dashboard.name}
                                </Select.Option>
                            ))
                        }
                    </Select>
                    <iframe
                        src={link}
                        frameBorder={0}
                        width={'100%'}
                        height={window.innerHeight-150}
                        allowTransparency
                    />
                </Card>
            </SimpleLayout>
        </>
    )
}
